/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PatientAIAssistantReceptionPatient,
  PatientAIAssistantReceptionPatientFromJSON,
  PatientAIAssistantReceptionPatientToJSON,
} from "../models";

export interface GetAIAssistantReceptionPatientRequest {
  xMGDXRECEPTIONAUTH: string;
}

/**
 *
 */
export class AiAssistantReceptionApi extends runtime.BaseAPI {
  /**
   * Get patient information required for AI assisted reception by the signed auth embedded in the reception code (QR). The patient is identified only by the auth in the X-MGDX-RECEPTION-AUTH header, and only the items necessary for reception are returned
   */
  async getAIAssistantReceptionPatientRaw(
    requestParameters: GetAIAssistantReceptionPatientRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PatientAIAssistantReceptionPatient>> {
    if (requestParameters.xMGDXRECEPTIONAUTH === null || requestParameters.xMGDXRECEPTIONAUTH === undefined) {
      throw new runtime.RequiredError(
        "xMGDXRECEPTIONAUTH",
        "Required parameter requestParameters.xMGDXRECEPTIONAUTH was null or undefined when calling getAIAssistantReceptionPatient."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters.xMGDXRECEPTIONAUTH !== undefined && requestParameters.xMGDXRECEPTIONAUTH !== null) {
      headerParameters["X-MGDX-RECEPTION-AUTH"] = String(requestParameters.xMGDXRECEPTIONAUTH);
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/ai-assistant-reception-patient`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PatientAIAssistantReceptionPatientFromJSON(jsonValue));
  }

  /**
   * Get patient information required for AI assisted reception by the signed auth embedded in the reception code (QR). The patient is identified only by the auth in the X-MGDX-RECEPTION-AUTH header, and only the items necessary for reception are returned
   */
  async getAIAssistantReceptionPatient(
    requestParameters: GetAIAssistantReceptionPatientRequest,
    initOverrides?: RequestInit
  ): Promise<PatientAIAssistantReceptionPatient> {
    return promiseRetry(
      (retry) =>
        this.getAIAssistantReceptionPatientRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
